import baseURL from "../modules/Inventory/common/axios";
class Commonservices {
  // Login(objlogin) {
  //   debugger;
  //   return baseURL.httpbaseURL.post("DoctorLogIn/LoginVerification", objlogin);
  // }
  Login(UserId, ModuleId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Login/GetLoginVerification?UserId=" + UserId + "&ModuleId=" + ModuleId
    );
  }
  GetRoles(EmailId, Password) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Login/GetRoles?EmailId=" + EmailId + "&Password=" + Password + ""
    );
  }
  GetRolesByUserId(UserId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Login/GetRolesByUserId?UserId=" + UserId + "&BranchId=" + BranchId + ""
    );
  }
  GetBranchesByUserId(UserId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Login/GetBranchesByUserId?UserId=" + UserId + ""
    );
  }
  LogOut(Key) {
    debugger;
    return baseURL.httpbaseURL.post("Common/LogoutSession?key=" + Key + "");
  }
  Session(objlogin) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("Common/Session", objlogin);
  }
  GetCountry(data) {
    return baseURL.httpbaseURL.post("DoctorCreation/GetCountry", data);
  }
}
export default new Commonservices();
